'use strict';

import sal from 'sal.js';

document.documentElement.classList.add('fg-js-ready');

function revealAnimations() {
  document.querySelectorAll('.fg-ani').forEach((element) => {
    element.classList.add('fg-ani--visible');
  });
}

window.addEventListener('load', function () {
  setTimeout(() => {
    try {
      sal();
    } catch (error) {
      revealAnimations();
      return;
    }

    window.setTimeout(revealAnimations, 900);
  }, 100);
});
